(function () {
  var roots = document.querySelectorAll('.password-launch[data-launch-datetime]');
  if (!roots.length) return;

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function renderCountdown(root) {
    var countdown = root.querySelector('.password-launch__countdown');
    if (!countdown) return;

    var targetRaw = (root.dataset.launchDatetime || '').trim();
    var expiredText = (root.dataset.expiredText || '00:00:00:00').trim();
    var targetMs = Date.parse(targetRaw);

    if (!targetRaw || Number.isNaN(targetMs)) {
      countdown.textContent = 'SET DATE';
      return;
    }

    function tick() {
      var diff = targetMs - Date.now();
      if (diff <= 0) {
        countdown.textContent = expiredText;
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      countdown.textContent = [pad(days), pad(hours), pad(minutes), pad(seconds)].join(':');
      window.setTimeout(tick, 1000);
    }

    tick();
  }

  roots.forEach(renderCountdown);
})();
